import { render, staticRenderFns } from "./shift.vue?vue&type=template&id=2a10b3ce&"
import script from "./shift.vue?vue&type=script&lang=js&"
export * from "./shift.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports